import apiClient from '@/Services/Clients/apiClient';

const LINKING_REFERENCE_BASE_URL: string = 'api/linkingreference';

export default class LinkingReferenceService {

  public static getAvailableRmsIds = (searchTerm: string) => {
    const uri = `${LINKING_REFERENCE_BASE_URL}/search/rmsids`;
    return apiClient.post(uri, searchTerm);
  };

  public static getAvailableCadIds = (searchTerm: string) => {
    const uri = `${LINKING_REFERENCE_BASE_URL}/search/cadids`;
    return apiClient.post(uri, searchTerm);
  };
}